import { z } from 'zod';
import { DeletedBySchema } from '../common/deleted-by.schema';

export const DeletedCompanyRowSchema = z.object({
  id: z.uuid(),
  workspaceId: z.uuid(),
  workspaceName: z.string().nullable(),
  organizationId: z.uuid(),
  name: z.string(),
  deletedAt: z.iso.datetime(),
  deletedBy: DeletedBySchema.nullable(),
});

export const ListDeletedCompaniesQuerySchema = z.object({ workspaceId: z.uuid().optional() });
export const ListDeletedCompaniesResponseSchema = z.object({ items: z.array(DeletedCompanyRowSchema) });

export type DeletedCompanyRow = z.infer<typeof DeletedCompanyRowSchema>;
export type ListDeletedCompaniesResponse = z.infer<typeof ListDeletedCompaniesResponseSchema>;
